const printButtons = document.querySelectorAll(".button__print");

printButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
        e.preventDefault();
        window.print();
    });
});

const applyButtons = document.querySelectorAll(".button__apply");

applyButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
        e.preventDefault();
        if (button.attributes.disabled !== undefined) {
            return;
        }
        const careerForm = document.getElementById("careerForm");
        let careerFormToggle = document.getElementById("careerFormToggle");
        if (careerForm) {
            careerForm.parentElement.classList.remove("h-0");
            const y = careerForm.getBoundingClientRect().top + window.pageYOffset - 100;
            window.scrollTo({ top: y, behavior: "smooth" });

            //hide buttons
            e.target.classList.add("hidden");
            careerFormToggle.classList.add("hidden");
        }
    });
});
